'use strict'

var PageComponent = require('src/components/page-view')

var Layout = PageComponent.LayoutPageTabs.extend({
  className: 'page page-filter-layout page-devices '
})

module.exports.Layout = Layout



// WEBPACK FOOTER //
// ./js/modules/page-devices/list/view.js